module.exports = __webpack_public_path__ + "img/188.ffce3358.png";